import React, {useEffect, useState} from 'react';
import {getHeaderNotification,  getFaqsData} from './../utils/endpoints'
import HeaderNotification from './components/headerNotification';
import Loading from './components/loading';
import Header from './components/header';
import Footer from './components/footer';
import { Container} from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import file01 from '../assets/pdf/notice-of-resignation-of-directors/2015.02.28_Notice-of-Resignation_Sanjeev-Kumar-Argal.pdf'
import file02 from '../assets/pdf/notice-of-resignation-of-directors/2015.04.02_Notice-of-Resignation_Mr-Laxman-Diwan.pdf'
import file03 from '../assets/pdf/notice-of-resignation-of-directors/2016.05.31_Notice-of-resignation_Sanjay-Daya.pdf'
import file04 from '../assets/pdf/notice-of-resignation-of-directors/2018.11.01_Notice-of-Resignation_Krishna-Nowal.pdf'
import file05 from '../assets/pdf/notice-of-resignation-of-directors/2021.04.16-Notice-of-Resignation_Rajesh-Mehta.pdf'
import file06 from '../assets/pdf/notice-of-resignation-of-directors/2021.11.23-Notice-of-Resignation_Sushisha-Devi-Paliwal.pdf'
import file07 from '../assets/pdf/notice-of-resignation-of-directors/2022.04.01-Notice-of-Resignation_Laxman-Diwan.pdf'
import file08 from '../assets/pdf/notice-of-resignation-of-directors/2022.04.01-Notice-of-Resignation_Madan-Lal-Paliwal.pdf'


const NoticeOfResignation = () => {
  const [headerNotificationData, setheaderNotificationData] = useState(null);
  const [faqs, setFaqs] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const faqs = await getFaqsData();
        const headerNotificationData = await getHeaderNotification();
        setheaderNotificationData(headerNotificationData);
        setFaqs(faqs);
        
        setIsLoading(false);
      } catch (error) {
        setError(error);
        setIsLoading(false);
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const faQSlice = faqs;

  if (isLoading) {
    return <div><Loading /></div>;
  }

  if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      <Helmet>
      <title>Notice of Resignation of Directors | Investors | Statue of Belief</title>
      </Helmet>
      <HeaderNotification compData={headerNotificationData}/>
      <Header />
      <section className='section-breadcrumb'>
      <Container>
      <ul>
            <li><a href="/">Home</a></li>
            <li>Notice of Resignation of Directors</li>
        </ul>
        <h1>Notice of Resignation of Directors</h1>
      </Container>
    </section>
    <section className='section-about'>
    <Container>
      <h2 class="mb-3">Notice of Resignation of Directors</h2>
        <ul className='list-item'>
            <li><a href={file01} download>2015.02.28_Notice of Resignation_Sanjeev Kumar Argal</a></li>
            <li><a href={file02} download>2015.04.02_Notice of Resignation_Mr-Laxman Diwan</a></li>
            <li><a href={file03} download>2016.05.31_Notice of resignation_Sanjay Daya</a></li>
            <li><a href={file04} download>2018.11.01_Notice of Resignation_Krishna Nowal</a></li>
            <li><a href={file05} download>2021.04.16-Notice of Resignation_Rajesh Mehta</a></li>
            <li><a href={file06} download>2021.11.23-Notice of Resignation_Sushisha Devi Paliwal</a></li>
            <li><a href={file07} download>2022.04.01-Notice of Resignation_Laxman Diwan</a></li>
            <li><a href={file08} download>2022.04.01-Notice of Resignation_Madan Lal Paliwal</a></li>
        </ul>
    </Container>
    </section>
    <Footer />
    </div>
  );
};

export default NoticeOfResignation;